import React, { useState } from 'react';
import { Button } from "reactstrap";
import { FaStar } from 'react-icons/fa';
import { RefreshCw } from 'lucide-react';

const StarRating = ({ selectedRating, getStarColor, onRatingSelected, onResetRating }) => {
  const [hover, setHover] = useState(null);

  const handleClick = (ratingValue) => {
    onRatingSelected(ratingValue); // Pass the selected rating to the parent
  };

  // Use either the hovered or selected rating to determine the color for all stars
  const currentRating = hover || selectedRating;

  return (
    <div>
      {[...Array(5)].map((star, index) => {
        const ratingValue = index + 1;

        return (
          <label key={index} style={{ cursor: "pointer" }}>
            <input
              type="radio"
              name="rating"
              value={selectedRating || undefined}
              onClick={() => handleClick(ratingValue)}
              style={{ display: 'none' }} // Hide the radio button
            />
            <FaStar
              className="star"
              color={ratingValue <= currentRating ? getStarColor(currentRating) : "#e4e5e9"}
              size={40}
              onMouseEnter={() => setHover(ratingValue)}
              onMouseLeave={() => setHover(null)}
            />
          </label>
        );
      })}
      <Button
        color="outline-secondary"
        onClick={onResetRating}
        style={{ marginLeft: "20px", marginTop: "2px", cursor: 'pointer', fontSize: '12px', maxWidth: '100%', padding: "1px 5px 3px 5px" }}
      >
        <RefreshCw size={12} />
      </Button>
    </div>
  );
};

export default StarRating;


